import PropTypes from 'prop-types';
import React from 'react';

const handleEventNoop = ev => {
  ev.stopPropagation();
  ev.preventDefault();
};

const NoopLink = ({ children, ...props }) => <span {...props} onClick={handleEventNoop}>{children}</span>;

NoopLink.propTypes = {
  children: PropTypes.node,
};

export default NoopLink;



// WEBPACK FOOTER //
// ./app/components/link/noop-link.js